export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9078.890343f2.jpg";